/**
 * Created by Florin David on 2019-04-27.
 */
import Action, { SET_TRANSLATION } from 'constants/action-types'

export default (state = {}, action: Action): Record<string, string> => {
  switch (action.type) {
    case SET_TRANSLATION:
      return action.payload.messages
    default:
      return state
  }
}
